<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="defaultTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">客户名称：</td>
            <td>{{deliveryAddress.customerName}}</td>
            <td class="tableLabel">联系人：</td>
            <td>{{deliveryAddress.contact}}</td>
            <td class="tableLabel">电话：</td>
            <td>{{deliveryAddress.telephone}}</td>
          </tr>
          <tr>
            <td class="tableLabel">所在区域：</td>
            <td>{{deliveryAddress.addressName}}</td>
            <td class="tableLabel">街道：</td>
            <td>{{deliveryAddress.streetName}}</td>
            <td class="tableLabel">流程状态：</td>
            <td>{{deliveryAddress.nodeDesc}}</td>
          </tr>
          <tr>
            <td class="tableLabel">详细地址：</td>
            <td colspan="3">{{deliveryAddress.addressDetail}}</td>
            <td class="tableLabel">是否默认地址：</td>
            <td>{{deliveryAddress.isDefault ? "是" : "否"}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注：</td>
            <td colspan="5">{{deliveryAddress.note}}</td>
          </tr>
        </table>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            附件
          </div>
          <el-table :data="deliveryAddress.accessoryVoList || []">
            <el-table-column type="index" align="center" label="行号" width="60"/>
            <el-table-column prop="fileName" align="center" label="附件名称"/>
            <el-table-column label="操作" align="center" width="120">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="fileDownload(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
  </div>
</template>

<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    name: "DeliveryAddressPreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        saveLoading: false,
        nodeId: 0,
        deliveryAddress: {
          pkid: "",
          customerName: "",
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getNodeValue();
    },
    methods: {
      getData() {
        this.$http.get("basic", `customerDeliveryAddress/${this.billId}`).then((res) => {
          this.deliveryAddress = res;
        }).catch(() => {
        });
      },
      fileDownload(row) {
        const filePath = row.filePath || "";
        const fileName = row.fileName || "";
        const str = filePath.slice(0, 1);
        // ~ 或 / 开头表示文件服务器上的相对路径（如 ~xxx、/attached/file/xxx），
        // 直接拼 fileServerUrl 直链下载，不能作为 uuid 传给 file/download 接口
        if (str === "~" || str === "/") {
          let base = window.config.fileServerUrl || "";
          if (base.endsWith("/")) {
            base = base.slice(0, -1);
          }
          let cleanPath = filePath.replace(/^~+/, "").replace(/^\/+/, "");
          let a = document.createElement("a");
          a.href = base + "/" + cleanPath;
          a.target = "_blank";
          a.download = fileName;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          let data = {
            name: row.fileName,
            uuid: row.filePath,
          };
          this.$http
              .exportFile("basic", "file/download", data)
              .then((res) => {
                let blob = new Blob([res.data], {type: "application"});
                let fileName = decodeURI(res.config.params.name);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  navigator.msSaveBlob(blob, fileName);
                } else {
                  let a = document.createElement("a");
                  a.href = URL.createObjectURL(blob);
                  a.download = fileName;
                  a.style.display = "none";
                  document.body.appendChild(a);
                  a.click();
                  URL.revokeObjectURL(a.href);
                  document.body.removeChild(a);
                }
              })
              .catch(() => {
                this.$message.error("下载失败");
              });
        }
      },
      toDoApprove() {
        if (this.params.untreadedFlowId === "0;submitter" && this.params.actionType === 2) {
          this.updateStatus();
        }
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          approveVar: approveVar,
          billParam: "",
        };
        this.doApprove(params);
      },
      doApprove(params) {
        this.$emit("loading-status", {"loading": true});
        this.$http
            .post("basic", "applications/doApprove", params)
            .then(() => {
              this.$emit("loading-status", {"loading": false});
              this.$message.success("操作成功");
              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/DeliveryAddressApprove",
              });
            }).catch(() => {
          this.$emit("loading-status", {"loading": false});
        });
      },
      updateStatus() {
        this.$http
            .get("basic", `customerDeliveryAddress/back/${this.deliveryAddress.pkid}`)
            .then(() => {
              this.$message.success("退回到提交人成功！！！");
            });
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
            .get("basic", "applications/approve", params)
            .then(resp => {
              this.nodeId = resp.nodeId;
              console.log(this.nodeId);
            });
      },
    },
  };
</script>

<style lang="scss">
table.defaultTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.defaultTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.defaultTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
